export const events = [
  {
    name: 'Vishaps and Where to Find Them',
    image: 'vishaps_and_where_to_find_them.jpg',
    pos: '0% 30%',
    start: '2021-03-05 04:00:00',
    end: '2021-03-12 04:00:00',
    color: '#F6AD55',
    showOnHome: true,
  },
  {
    name: 'A Wanmin Welcome - Web Event',
    pos: '0% 45%',
    image: 'a_wanmin_welcome.png',
    start: '2021-03-16 13:00:00',
    end: '2021-03-25 23:59:00',
    color: '#FAE2B4',
    url: 'https://webstatic-sea.mihoyo.com/ys/event/e20210316cooking-sea/index.html?lang=en-us?utm_source=hoyolab&utm_medium=banner',
    showOnHome: true,
  },
  {
    name: 'Outland Gastronomy - Daily Login Event',
    pos: '0% 50%',
    image: 'outland_gastronomy.jpg',
    start: '2021-03-17 06:00:00',
    end: '2021-04-01 04:00:00',
    color: '#DDD7E8',
    zoom: '180%',
    url: 'https://genshin.mihoyo.com/en/news/detail/9262',
    showOnHome: true,
  },
  {
    name: 'Contending Tides Event',
    pos: '0% 10%',
    image: 'contending_tides.jpg',
    start: '2021-04-02 10:00:00',
    end: '2021-04-12 04:00:00',
    color: '#6C99F7',
    zoom: '180%',
    url: 'https://www.hoyolab.com/genshin/article/275307',
    showOnHome: true,
  },
  {
    name: 'A Thousand Questions With Paimon',
    pos: '60% 30%',
    image: 'a_thousand_questions_with_paimon.jpg',
    start: '2021-04-06 13:00:00',
    end: '2021-04-08 23:59:59',
    color: '#EFDEB4',
    zoom: '180%',
    url: 'https://genshin.mihoyo.com/en/news/detail/9694',
    showOnHome: true,
  },
  {
    name: 'Wishful Drops - Oceanid Event',
    pos: '0% 20%',
    image: 'wishful_drops.jpg',
    start: '2021-04-09 10:00:00',
    end: '2021-04-16 04:00:00',
    color: '#579DE5',
    zoom: '170%',
    url: 'https://www.hoyolab.com/genshin/article/286280',
    showOnHome: true,
  },
  {
    name: 'Hilidream Camp',
    pos: '0% 58%',
    image: 'hilidream_camp.png',
    start: '2021-04-21 13:00:00',
    end: '2021-04-27 23:59:59',
    color: '#FAF8EB',
    zoom: '180%',
    url: 'https://webstatic-sea.mihoyo.com/ys/event/e20210421-homeland/index.html',
    showOnHome: true,
  },
  {
    name: 'To the Stars Once More',
    pos: '20% 15%',
    image: 'to_the_stars_once_more.jpg',
    start: '2021-04-28 13:00:00',
    end: '2021-05-17 23:59:59',
    color: '#DDC59A',
    zoom: '180%',
    url: 'https://genshin.mihoyo.com/en/news/detail/12368',
    showOnHome: true,
  },
  {
    name: 'Windtrace',
    pos: '0% 80%',
    image: 'windtrace.jpg',
    start: '2021-05-14 10:00:00',
    end: '2021-05-24 04:00:00',
    color: '#E8D8B7',
    zoom: '190%',
    url: 'https://genshin.mihoyo.com/en/news/detail/12281',
    showOnHome: true,
  },
  {
    name: 'Battlefront: Misty Dungeon',
    pos: '0% 45%',
    image: 'battlefront_misty_dungeon.jpg',
    start: '2021-05-21 10:00:00',
    end: '2021-05-31 04:00:00',
    color: '#95C9B9',
    zoom: '200%',
    url: 'https://www.hoyolab.com/genshin/article/377249',
    showOnHome: true,
  },
  {
    name: 'Mimi Tomo',
    pos: '0% 35%',
    image: 'mimi_tomo_update.jpg',
    start: '2021-05-27 10:00:00',
    end: '2021-06-06 04:00:00',
    color: '#E5C18B',
    zoom: '200%',
    url: 'https://www.hoyolab.com/genshin/article/387817',
    showOnHome: true,
  },
  {
    name: 'Echoing Tales',
    pos: '0% 15%',
    image: 'echoing_tales.png',
    start: '2021-06-09 11:00:00',
    end: '2021-07-21 06:00:00',
    color: '#90CEF5',
    zoom: '230%',
    url: 'https://www.hoyolab.com/genshin/article/415684',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Legend of the Vagabond Sword',
    pos: '0% 45%',
    image: 'legend_of_the_vagabond_sword.png',
    start: '2021-06-25 10:00:00',
    end: '2021-07-08 03:59:59',
    color: '#7A92FF',
    zoom: '180%',
    showOnHome: true,
  },
  {
    name: 'Kaboomball Kombat',
    pos: '0% 15%',
    image: 'kaboomball_kombat.png',
    start: '2021-07-02 10:00:00',
    end: '2021-07-12 04:00:00',
    color: '#A8E4FC',
    zoom: '150%',
    url: 'https://www.hoyolab.com/genshin/article/503383',
    showOnHome: true,
  },
  {
    name: "Traveler's Picture Book Web Event",
    pos: '50% 83%',
    image: 'traveler_picture_book.jpg',
    start: '2021-07-03 11:00:00',
    end: '2021-07-13 03:59:59',
    color: '#F3EFC9',
    zoom: '150%',
    url: 'https://www.hoyolab.com/genshin/article/512380',
    showOnHome: true,
  },
  {
    name: 'Never-Ending Battle',
    pos: '0% 55%',
    image: 'neverending_battle.png',
    start: '2021-07-09 10:00:00',
    end: '2021-07-19 04:00:00',
    color: '#CCFFCB',
    zoom: '160%',
    url: 'https://twitter.com/GenshinImpact/status/1409001038758121478',
    showOnHome: true,
  },
  {
    name: 'Mysterious Voyage Web Event',
    pos: '70% 50%',
    image: 'mysterious_voyage.jpg',
    start: '2021-07-13 04:00:00',
    end: '2021-07-20 23:59:59',
    color: '#FFBE7D',
    zoom: '120%',
    url: 'https://www.hoyolab.com/genshin/article/543290',
    showOnHome: true,
  },
  {
    name: 'Thunder Sojourn',
    pos: '0% 25%',
    image: 'thunder_sojourn.jpg',
    start: '2021-07-22 10:00:00',
    end: '2021-08-09 03:59:59',
    color: '#F0DBFF',
    zoom: '200%',
    url: 'https://genshin.mihoyo.com/en/news/detail/14337',
    showOnHome: true,
  },
  {
    name: 'Summer Night Mementos',
    pos: '0% 40%',
    image: 'summer_night_mementos.jpg',
    start: '2021-08-05 04:00:00',
    end: '2021-08-11 23:59:59',
    color: '#FFFEF9',
    zoom: '200%',
    url: 'https://mhy.link/071OHHA6',
    showOnHome: true,
  },
  {
    name: 'Lost Riches',
    pos: '0% 50%',
    image: 'lost_riches_2.jpg',
    start: '2021-08-06 10:00:00',
    end: '2021-08-16 03:59:59',
    color: '#FFF2DC',
    zoom: '170%',
    url: 'https://genshin.mihoyo.com/en/news/detail/14337',
    showOnHome: true,
  },
  {
    name: 'Theater Mechanicus: Stage of Wonders',
    pos: '0% 45%',
    image: 'theater_mechanicus_wonders.jpg',
    start: '2021-08-12 10:00:00',
    end: '2021-08-26 03:59:59',
    color: '#F8EAC4',
    zoom: '200%',
    url: 'https://www.hoyolab.com/genshin/article/661106',
    showOnHome: true,
  },
  {
    name: 'Phantom Flow',
    pos: '0% 20%',
    image: 'phantom_flow.jpg',
    start: '2021-08-20 10:00:00',
    end: '2021-08-30 03:59:59',
    color: '#FFB6EB',
    zoom: '100%',
    url: 'https://www.hoyolab.com/genshin/article/661106',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '20% 35%',
    image: 'ley_line_overflow.jpg',
    start: '2021-08-23 04:00:00',
    end: '2021-08-30 03:59:59',
    color: '#43DA8C',
    zoom: '150%',
    url: 'https://www.hoyolab.com/genshin/article/661106',
    showOnHome: true,
  },
  {
    name: 'Lunar Realm',
    pos: '0% 50%',
    image: 'lunar_realm.jpg',
    start: '2021-09-10 10:00:00',
    end: '2021-09-20 03:59:59',
    color: '#3585FF',
    zoom: '180%',
    url: 'https://www.hoyolab.com/genshin/article/780932',
    showOnHome: true,
  },
  {
    name: 'Spectral Secrets',
    pos: '0% 25%',
    image: 'spectral_secrets.jpg',
    start: '2021-09-19 10:00:00',
    end: '2021-09-26 03:59:59',
    color: '#F6F5F0',
    zoom: '170%',
    url: 'https://www.hoyolab.com/genshin/article/780934',
    showOnHome: true,
  },
  {
    name: 'Moonlight Merriment',
    pos: '100% 15%',
    image: 'moonlight_merriment.jpg',
    start: '2021-09-27 10:00:00',
    end: '2021-10-11 03:59:59',
    color: '#FF7B69',
    zoom: '150%',
    url: 'https://www.hoyolab.com/genshin/article/780930',
    showOnHome: true,
  },
  {
    name: 'An Unforgettable Journey - Anniversary Web Event',
    pos: '0% 55%',
    image: 'an_unforgettable_journey.jpg',
    start: '2021-09-28 04:00:00',
    end: '2021-10-12 23:59:59',
    color: '#5A8EBE',
    zoom: '100%',
    url: 'https://mhy.link/adfsJJA6',
    showOnHome: true,
  },
  {
    name: 'Passage of Clouds and Stars - Daily Login',
    pos: '0% 40%',
    image: 'passage_of_clouds_and_stars.jpg',
    start: '2021-09-28 10:00:00',
    end: '2021-10-11 03:59:59',
    color: '#547BE4',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/780929',
    showOnHome: true,
  },
  {
    name: "Aloy's Exploration Journal",
    pos: '0% 30%',
    image: 'aloys_exploration_journal.jpg',
    start: '2021-10-13 10:00:00',
    end: '2021-10-27 23:59:59',
    color: '#D3EEF9',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1206113',
    showOnHome: true,
  },
  {
    name: "Tuned to the World's Sound",
    pos: '0% 10%',
    image: 'tuned_to_the_worlds_sounds.jpg',
    start: '2021-10-15 10:00:00',
    end: '2021-10-25 03:59:59',
    color: '#81A6BC',
    zoom: '300%',
    url: 'https://www.hoyolab.com/article/1206131',
    showOnHome: true,
  },
  {
    name: 'Yummy! Barbecue Under the Stars',
    pos: '0% 35%',
    image: 'barbecue_under_the_stars.jpg',
    start: '2021-11-01 10:00:00',
    end: '2021-11-07 23:59:59',
    color: '#D3EEF9',
    zoom: '300%',
    url: 'https://www.hoyolab.com/article/1327554',
    showOnHome: true,
  },
  {
    name: 'Shadow of the Ancients',
    pos: '0% 50%',
    image: 'shadow_of_the_ancients.jpg',
    start: '2021-11-05 10:00:00',
    end: '2021-11-15 03:59:59',
    color: '#94D3FA',
    zoom: '180%',
    url: 'https://www.hoyolab.com/article/1347382',
    showOnHome: true,
  },
  {
    name: 'Dreams of Bloom',
    pos: '0% 50%',
    image: 'dreams_of_bloom.jpg',
    start: '2021-11-12 10:00:00',
    end: '2021-11-18 03:59:59',
    color: '#FFDB7F',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1321455',
    showOnHome: true,
  },
  {
    name: 'Shadows Amidst Snowstorms',
    pos: '0% 20%',
    zoom: '180%',
    image: 'shadows_amidst_snowstorms.jpg',
    start: '2021-11-25 11:00:00',
    end: '2021-12-13 03:59:59',
    color: '#dfe9f2',
    url: 'https://www.hoyolab.com/article/1432656',
    showOnHome: true,
  },
  {
    name: "Traveler's Picture Book Web Event",
    pos: '100% 50%',
    image: 'travelers_picture_book.jpg',
    start: '2021-12-03 11:00:00',
    end: '2021-12-13 03:59:59',
    color: '#DEECF7',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/1531728',
    showOnHome: true,
  },
  {
    name: 'Bantan Sango Case Files: The Warrior Dog',
    pos: '0% 60%',
    image: 'warrior_dog.jpg',
    start: '2021-12-07 10:00:00',
    end: '2021-12-20 03:59:59',
    color: '#838CE7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1432656',
    showOnHome: true,
  },
  {
    name: 'Let the Arataki Gang Show Begin Web Event',
    pos: '100% 40%',
    image: 'let_the_arataki_gang_show_begin.jpg',
    start: '2021-12-09 12:00:00',
    end: '2021-12-13 23:59:59',
    color: '#FDFB85',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/1586790',
    showOnHome: true,
  },
  {
    name: 'Misty Dungeon: Realm of Light',
    pos: '0% 60%',
    image: 'misty_dungeon.jpg',
    start: '2021-12-17 10:00:00',
    end: '2021-12-27 03:59:59',
    color: '#8EC0B3',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1653437',
    showOnHome: true,
  },
  {
    name: 'Energy Amplifier Fruition',
    pos: '0% 50%',
    image: 'energy_amplifier_fruition.jpg',
    start: '2021-12-24 10:00:00',
    end: '2022-01-03 03:59:59',
    color: '#8FE3F0',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1732200',
    showOnHome: true,
  },
  {
    name: 'The Crane in the Clouds Web Event',
    pos: '100% 30%',
    image: 'the_crane_in_the_clouds.jpg',
    start: '2021-12-31 12:00:00',
    end: '2022-01-04 23:59:59',
    color: '#FBF5DB',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/1823311',
    showOnHome: true,
  },
  {
    name: 'A Study in Potions',
    pos: '0% 50%',
    image: 'a_study_in_potions.jpg',
    start: '2022-01-07 10:00:00',
    end: '2022-01-17 03:59:59',
    color: '#9FE0D4',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1823273',
    showOnHome: true,
  },
  {
    name: 'Windtrace',
    pos: '0% 80%',
    image: 'windtrace_2.jpg',
    start: '2022-01-13 10:00:00',
    end: '2022-01-27 03:59:59',
    color: '#FFF6DF',
    zoom: '170%',
    url: 'https://www.hoyolab.com/article/1823273',
    showOnHome: true,
  },
  {
    name: 'May Fortune Find You - Daily Login',
    pos: '0% 30%',
    image: 'daily_login.jpg',
    start: '2022-01-25 04:00:00',
    end: '2022-02-09 03:59:59',
    color: '#F18B53',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1823190',
    showOnHome: true,
  },
  {
    name: 'Eight Locales Over Mountains and Seas',
    pos: '0% 60%',
    image: 'eight_locales_over_mountains_and_seas.jpg',
    start: '2022-02-04 10:00:00',
    end: '2022-02-14 03:59:59',
    color: '#94D1D0',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1823273',
    showOnHome: true,
  },
  {
    name: 'Flowing Lights and Colors',
    pos: '0% 50%',
    image: 'flowing_lights_and_colors.jpg',
    start: '2022-02-09 00:00:00',
    end: '2022-02-15 14:59:59',
    color: '#BB71AD',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/1823191',
    showOnHome: true,
  },
  {
    name: 'Three Realms Gateway Offering',
    pos: '0% 0%',
    zoom: '100%',
    image: 'three_realms_gateway_offering.jpg',
    start: '2022-02-17 10:00:00',
    end: '2022-03-30 06:00:00',
    color: '#9c9cef',
    url: 'https://www.hoyolab.com/article/3356118',
    showOnHome: true,
  },
  {
    name: 'Of Drink A-Dreaming',
    pos: '0% 50%',
    image: 'of_drink_a_dreaming.jpg',
    start: '2022-03-10 10:00:00',
    end: '2022-03-21 03:59:59',
    color: '#e4d9c5',
    zoom: '180%',
    url: 'https://www.hoyolab.com/article/3714058',
    showOnHome: true,
  },
  {
    name: 'When Flowers Bloom',
    pos: '0% 30%',
    image: 'when_flowers_bloom.jpg',
    start: '2022-03-25 12:00:00',
    end: '2022-03-30 23:59:59',
    color: '#8481da',
    zoom: '170%',
    url: 'https://www.hoyolab.com/article/3949309',
    showOnHome: true,
  },
  {
    name: 'Hues of the Violet Garden',
    pos: '0% 15%',
    zoom: '200%',
    image: 'hues_of_the_violet_garden.jpg',
    start: '2022-04-07 10:00:00',
    end: '2022-04-25 03:59:59',
    color: '#d98498',
    url: 'https://www.hoyolab.com/article/3993068',
    showOnHome: true,
  },
  {
    name: 'Vibro-Crystal Research',
    pos: '0% 25%',
    image: 'vibro_crysta_research.jpg',
    start: '2022-04-21 10:00:00',
    end: '2022-05-05 03:59:59',
    color: '#64a3f3',
    zoom: '220%',
    url: 'https://www.hoyolab.com/article/4245426',
    showOnHome: true,
  },
  {
    name: 'Marvelous Merchandise',
    pos: '0% 80%',
    image: 'marvelous_merchandise_event.jpg',
    start: '2022-05-06 10:00:00',
    end: '2022-05-13 03:59:59',
    color: '#fad688',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/4245426',
    showOnHome: true,
  },
  {
    name: 'Spices From the West',
    pos: '0% 40%',
    zoom: '200%',
    image: 'spices_from_the_west.jpg',
    start: '2022-05-14 10:00:00',
    end: '2022-06-07 03:59:59',
    color: '#83bfb4',
    url: 'https://www.hoyolab.com/article/4592260',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    image: 'overflowing_mastery.jpg',
    start: '2022-05-22 04:00:00',
    end: '2022-05-29 03:59:59',
    color: '#f5debc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/4592260',
    showOnHome: true,
  },
  {
    name: 'Perilous Trail',
    pos: '0% 20%',
    zoom: '150%',
    image: 'perilous_trail.jpg',
    start: '2022-05-31 06:00:00',
    end: '2022-06-20 03:59:59',
    color: '#c9bcff',
    url: 'https://www.hoyolab.com/article/4998961',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'The Almighty Arataki Great and Glorious Drumalong Festival',
    pos: '0% 50%',
    image: 'drumalong_festival.jpg',
    start: '2022-06-13 10:00:00',
    end: '2022-07-04 03:59:59',
    color: '#ffca92',
    zoom: '250%',
    url: 'https://www.hoyolab.com/article/5350611',
    showOnHome: true,
  },
  {
    name: 'A Muddy Bizzare Adventure',
    pos: '0% 50%',
    image: 'a_muddy_bizzare_adventure.jpg',
    start: '2022-06-22 10:00:00',
    end: '2022-07-04 03:59:59',
    color: '#8882e2',
    zoom: '220%',
    url: 'https://www.hoyolab.com/article/5513175',
    showOnHome: true,
  },
  {
    name: 'Core of the Apparatus',
    pos: '50% 50%',
    zoom: '150%',
    image: 'core_of_the_apparatus.jpg',
    start: '2022-06-29 10:00:00',
    end: '2022-07-11 03:59:59',
    color: '#fdf9f4',
    url: 'https://www.hoyolab.com/article/5444663',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2022-07-04 04:00:00',
    end: '2022-07-11 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/5444663',
    showOnHome: true,
  },
  {
    name: 'Summertime Odyssey',
    pos: '40% 20%',
    zoom: '200%',
    image: 'summertime_odyssey.jpg',
    start: '2022-07-15 10:00:00',
    end: '2022-08-24 06:00:00',
    color: '#7eebff',
    url: 'https://www.hoyolab.com/article/5958494',
    showOnHome: true,
  },
  {
    name: 'Mesmerizing Dream at Sea',
    pos: '20% 23%',
    image: 'mesmerizing_dream_at_sea.jpg',
    start: '2022-07-22 10:00:00',
    end: '2022-07-31 23:59:59',
    color: '#8cd8f1',
    zoom: '300%',
    url: 'https://www.hoyolab.com/article/6129641',
    showOnHome: true,
  },
  {
    name: 'Hidden Strife',
    pos: '0% 30%',
    image: 'hidden_strife.jpg',
    start: '2022-07-27 10:00:00',
    end: '2022-08-15 03:59:59',
    color: '#ff7c84',
    zoom: '220%',
    url: 'https://www.hoyolab.com/article/6171423',
    showOnHome: true,
  },
  {
    name: 'Reminiscent Regimen',
    pos: '0% 35%',
    image: 'reminiscent_regimen.jpg',
    start: '2022-08-04 10:00:00',
    end: '2022-08-15 03:59:59',
    color: '#82cff9',
    zoom: '250%',
    url: 'https://www.hoyolab.com/article/6533766',
    showOnHome: true,
  },
  {
    name: 'Evermotion Mechanical Painting',
    pos: '0% 30%',
    image: 'evermotion_mechanical_painting.jpg',
    start: '2022-08-12 10:00:00',
    end: '2022-08-22 03:59:59',
    color: '#ffc284',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/6197391',
    showOnHome: true,
  },
  {
    name: 'A Journey Through Pages',
    pos: '20% 23%',
    image: 'a_journey_through_pages.jpg',
    start: '2022-08-17 12:00:00',
    end: '2022-08-23 23:59:59',
    color: '#f0ece1',
    zoom: '300%',
    url: 'https://www.hoyolab.com/article/7018436',
    showOnHome: true,
  },
  {
    name: 'Go Go, Forest Rangers!',
    pos: '0% 30%',
    image: 'go_go_forest_rangers.jpg',
    start: '2022-08-19 12:00:00',
    end: '2022-08-24 23:59:59',
    color: '#2dd378',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/7056771',
    showOnHome: true,
  },
  {
    name: 'Graven Innocence',
    pos: '0% 20%',
    zoom: '200%',
    image: 'graven_innocence.jpg',
    start: '2022-08-24 06:00:00',
    end: '2022-09-28 06:00:00',
    color: '#c4e6f8',
    url: 'https://www.hoyolab.com/article/7113808',
    showOnHome: true,
  },
  {
    name: 'Lost Riches',
    pos: '0% 50%',
    image: 'lost_riches_2.jpg',
    start: '2022-09-02 10:00:00',
    end: '2022-09-19 03:59:59',
    color: '#FFF2DC',
    zoom: '250%',
    url: 'https://www.hoyolab.com/article/7113923',
    showOnHome: true,
  },
  {
    name: 'Fayz Trials',
    pos: '0% 40%',
    image: 'fayz_trials.jpg',
    start: '2022-09-08 10:00:00',
    end: '2022-09-26 03:59:59',
    color: '#ff9486',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/7113923',
    showOnHome: true,
  },
  {
    name: 'Adventure in the Forest',
    pos: '0% 20%',
    image: 'adventure_in_the_forest.jpg',
    start: '2022-08-29 12:00:00',
    end: '2022-09-11 23:59:59',
    color: '#a7d0a6',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/7293007',
    showOnHome: true,
  },
  {
    name: 'Tablet Analytics',
    pos: '0% 50%',
    image: 'tablet_analytics_r.jpg',
    start: '2022-09-15 10:00:00',
    end: '2022-09-26 03:59:59',
    color: '#80d7b0',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/8843590',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '20% 35%',
    image: 'leyline_overflow.jpg',
    start: '2022-09-20 04:00:00',
    end: '2022-09-27 03:59:59',
    color: '#43DA8C',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/8555140',
    showOnHome: true,
  },
  {
    name: 'Trial of the Scorching Sands',
    pos: '60% 30%',
    image: 'trial_of_the_scorching_sands.jpg',
    start: '2022-09-23 12:00:00',
    end: '2022-09-28 23:59:59',
    color: '#ebcca0',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/9182888',
    showOnHome: true,
  },
  {
    name: 'Genshin Concert 2022',
    pos: '60% 30%',
    image: 'genshin_concert_2022.jpg',
    start: '2022-09-26 04:00:00',
    end: '2022-10-01 23:59:59',
    color: '#e2feff',
    zoom: '100%',
    url: 'https://genshin.hoyoverse.com/concert2022',
    showOnHome: true,
  },
  {
    name: 'Path of Gleaming Jade - Daily Login',
    pos: '0% 45%',
    image: 'path_of_gleaming_jade.jpg',
    start: '2022-10-14 10:00:00',
    end: '2022-10-31 03:59:59',
    color: '#df8bb9',
    zoom: '250%',
    url: 'https://www.hoyolab.com/article/9331343',
    showOnHome: true,
  },
  {
    name: 'Of Travels and Treasures',
    pos: '60% 40%',
    image: 'of_travels_and_treasures.jpg',
    start: '2022-09-28 06:00:00',
    end: '2022-10-07 23:59:59',
    color: '#82b4ce',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/9331351',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Canvas of Starlight Memories',
    pos: '30% 60%',
    image: 'canvas_of_starlight_memory.jpg',
    start: '2022-09-28 12:00:00',
    end: '2022-10-12 23:59:59',
    color: '#f7f8f9',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/9406156',
    showOnHome: true,
  },
  {
    name: 'Of Ballads and Brews',
    pos: '0% 20%',
    zoom: '100%',
    image: 'of_ballads_and_brews.jpg',
    start: '2022-09-29 10:00:00',
    end: '2022-10-17 03:59:59',
    color: '#aae9f1',
    url: 'https://www.hoyolab.com/article/9402660',
    showOnHome: true,
  },
  {
    name: 'A Walk Through the Woods',
    pos: '0% 0%',
    image: 'a_walk_through_the_woods.jpg',
    start: '2022-09-29 12:00:00',
    end: '2022-10-7 23:59:59',
    color: '#ccd9c5',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/9474002',
    showOnHome: true,
  },
  {
    name: 'Hidden Civilizations',
    pos: '0% 30%',
    image: 'hidden_civilizations.jpg',
    start: '2022-09-29 12:00:00',
    end: '2022-10-31 23:59:59',
    color: '#8cd5a8',
    zoom: '120%',
    url: 'https://act.hoyolab.com/puzzle/bbs/pz_fKWaqWI9U4/index.html?game_biz=bbs_oversea&mhy_presentation_style=fullscreen&mhy_auth_required=true&utm_source=hoyolab&utm_medium=web&utm_campaign=post',
    showOnHome: true,
  },
  {
    name: 'Dance of Gratitude',
    pos: '0% 40%',
    image: 'dance_of_gratitude.jpg',
    start: '2022-10-08 12:00:00',
    end: '2022-10-13 23:59:59',
    color: '#f0e3db',
    zoom: '200%',
    url: 'https://act.hoyoverse.com/ys/event/e20221008nilou/index.html?game_biz=hk4e_global&mhy_presentation_style=fullscreen&mhy_auth_required=true&mhy_landscape=true&mhy_hide_status_bar=true&utm_source=hoyolab&utm_medium=post',
    showOnHome: true,
  },
  {
    name: 'Hyakunin Ikki',
    pos: '0% 55%',
    image: 'hyakunin_ikki.jpg',
    start: '2022-10-10 10:00:00',
    end: '2022-10-24 03:59:59',
    color: '#e494b4',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/9331594',
    showOnHome: true,
  },
  {
    name: 'Wind Chaser',
    pos: '20% 20%',
    zoom: '200%',
    image: 'wind_chaser_1.jpg',
    start: '2022-10-17 10:00:00',
    end: '2022-10-31 03:59:59',
    color: '#43f4cd',
    url: 'https://www.hoyolab.com/article/12081070',
    showOnHome: true,
  },
  {
    name: "Star-Seeker's Sojourn",
    pos: '20% 50%',
    image: 'star_seeker_sojourn_1.jpg',
    start: '2022-10-21 10:00:00',
    end: '2022-10-31 03:59:59',
    color: '#84be69',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/12081070',
    showOnHome: true,
  },
  {
    name: 'Songs of the Forest',
    pos: '0% 30%',
    image: 'songs_of_the_forest.jpg',
    start: '2022-10-24 12:00:00',
    end: '2022-10-31 23:59:59',
    color: '#fffbed',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/12973970',
    showOnHome: true,
  },
  {
    name: 'May Your Dreams of Wisdom Come True',
    pos: '0% 30%',
    image: 'may_your_dreams_of_wisdom_come_true.png',
    start: '2022-10-28 12:00:00',
    end: '2022-11-02 23:59:59',
    color: '#f5f8c6',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/13156542',
    showOnHome: true,
  },
  {
    name: "Hilichurls' Treasure Trove",
    pos: '50% 75%',
    image: 'hilicurl_treasure_trove.jpg',
    start: '2022-11-03 10:00:00',
    end: '2022-12-04 23:59:59',
    color: '#d7eff3',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/13340875',
    showOnHome: true,
  },
  {
    name: "Adventurer's Trial",
    pos: '0% 70%',
    zoom: '200%',
    image: 'adventurers_trials.jpg',
    start: '2022-11-04 10:00:00',
    end: '2022-11-21 03:59:59',
    color: '#e5c2ee',
    url: 'https://www.hoyolab.com/article/13297789',
    showOnHome: true,
  },
  {
    name: 'Fabulous Fungus Frenzy',
    pos: '0% 80%',
    zoom: '200%',
    image: 'fabulous_fungus_frenzy.jpg',
    start: '2022-11-10 10:00:00',
    end: '2022-11-28 03:59:59',
    color: '#fad688',
    url: 'https://www.hoyolab.com/article/13595311',
    showOnHome: true,
  },
  {
    name: 'Outside the Canvas, Inside the Lens: Greenery Chapter',
    pos: '0% 25%',
    image: 'outside_the_canvas_inside_the_lens.jpg',
    start: '2022-11-16 10:00:00',
    end: '2022-12-05 03:59:59',
    color: '#d1dab5',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/13718763',
    showOnHome: true,
  },
  {
    name: 'Hypostatic Symphony: Dissonant Verse',
    pos: '0% 60%',
    zoom: '100%',
    image: 'hypostatic_symphony.jpg',
    start: '2022-11-24 10:00:00',
    end: '2022-12-05 03:59:59',
    color: '#c9e880',
    url: 'https://www.hoyolab.com/article/13880027',
    showOnHome: true,
  },
  {
    name: 'Marvelous Merchandise',
    pos: '0% 50%',
    zoom: '200%',
    image: 'marvelous_merchandise_event.jpg',
    start: '2022-11-28 10:00:00',
    end: '2022-12-05 03:59:59',
    color: '#c5ffbc',
    url: 'https://www.hoyolab.com/article/13736970',
    showOnHome: true,
  },
  {
    name: 'Fluttering Footsteps in the Fields',
    pos: '0% 30%',
    image: 'fluttering_footsteps.jpg',
    start: '2022-12-05 10:00:00',
    end: '2022-12-10 23:59:59',
    color: '#d5ebdc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/14150297',
    showOnHome: true,
  },
  {
    name: 'Duelist Rising',
    pos: '0% 30%',
    image: 'duelist_rising.jpg',
    start: '2022-12-05 10:00:00',
    end: '2022-12-14 23:59:59',
    color: '#efe7da',
    zoom: '200%',
    url: 'https://hoyo.link/3b28BJAd',
    showOnHome: true,
  },
  {
    name: 'Akitsu Kimodameshi',
    pos: '0% 15%',
    zoom: '220%',
    image: 'akitsu_kimodameshi.jpg',
    start: '2022-12-15 10:00:00',
    end: '2023-01-02 03:59:59',
    color: '#c2a5f1',
    url: 'https://www.hoyolab.com/article/14330068',
    showOnHome: true,
  },
  {
    name: 'Misty Dungeon: Realm of Sand',
    pos: '0% 50%',
    zoom: '300%',
    image: 'misty_dungeon_realm_of_sand_temp.jpg',
    start: '2022-12-09 10:00:00',
    end: '2022-12-19 03:59:59',
    color: '#fceea3',
    url: 'https://www.hoyolab.com/article/14201704',
    showOnHome: true,
  },
  {
    name: 'Across the Wilderness',
    pos: '0% 50%',
    zoom: '100%',
    image: 'across_the_wilderness.jpg',
    start: '2023-01-03 10:00:00',
    end: '2023-01-13 03:59:59',
    color: '#d9f8e2',
    url: 'https://www.hoyolab.com/article/14710888',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 70%',
    zoom: '200%',
    image: 'leyline_overflow.jpg',
    start: '2023-01-09 10:00:00',
    end: '2023-01-16 03:59:59',
    color: '#43DA8C',
    url: 'https://www.hoyolab.com/article/14503342',
    showOnHome: true,
  },
  {
    name: 'May Fortune Find You - Daily Login',
    pos: '0% 40%',
    zoom: '200%',
    image: 'daily_login_may_fortune_find_you_2.jpg',
    start: '2023-01-19 04:00:00',
    end: '2023-02-03 03:59:59',
    color: '#6384e3',
    url: 'https://www.hoyolab.com/article/15074968',
    showOnHome: true,
  },
  {
    name: 'The Exquisite Night Chimes',
    pos: '0% 10%',
    zoom: '200%',
    image: 'the_exquisite_night_chimes.jpg',
    start: '2023-01-19 10:00:00',
    end: '2023-02-06 03:59:59',
    color: '#7485dc',
    url: 'https://www.hoyolab.com/article/15074939',
    showOnHome: true,
  },
  {
    name: '"Genius Invokation TCG" Heated Battle Mode: Omnipotent Guide',
    pos: '0% 50%',
    zoom: '200%',
    image: 'genius_invokation_tcg.jpg',
    start: '2023-01-28 10:00:00',
    end: '2023-02-06 05:59:59',
    color: '#faf0c5',
    url: 'https://www.hoyolab.com/article/15074968',
    showOnHome: true,
  },
  {
    name: 'Second Blooming',
    pos: '0% 15%',
    zoom: '200%',
    image: 'second_blooming.jpg',
    start: '2023-01-31 10:00:00',
    end: '2023-02-13 03:59:59',
    color: '#e8e3df',
    url: 'https://www.hoyolab.com/article/15074939',
    showOnHome: true,
  },
  {
    name: 'Iridescent Splendor',
    pos: '0% 50%',
    zoom: '200%',
    image: 'iridescent_splendor.jpg',
    start: '2023-02-05 04:00:00',
    end: '2023-02-29 05:59:59',
    color: '#77a8e7',
    url: 'https://www.hoyolab.com/article/15074968',
    showOnHome: true,
  },
  {
    name: "Warrior's Spirit",
    pos: '0% 40%',
    zoom: '200%',
    image: 'warriors_spirit.jpg',
    start: '2023-02-09 10:00:00',
    end: '2023-02-20 03:59:59',
    color: '#c769a2',
    url: 'https://www.hoyolab.com/article/15074939',
    showOnHome: true,
  },
  {
    name: 'Almighty Arataki Extraordinary and Exhilarating Extreme Beetle Brawl',
    pos: '0% 50%',
    zoom: '250%',
    image: 'almighty_arataki_extraordinary_and_exhilarating_extreme_beetle_brawl.jpg',
    start: '2023-02-16 10:00:00',
    end: '2023-02-27 03:59:59',
    color: '#c8bcae',
    url: 'https://www.hoyolab.com/article/15074939',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    zoom: '200%',
    image: 'overflowing_mastery.jpg',
    start: '2023-02-20 04:00:00',
    end: '2023-02-27 03:59:59',
    color: '#f5debc',
    url: 'https://www.hoyolab.com/article/15074968',
    showOnHome: true,
  },
  {
    name: 'Scarlet Sand Sojourn',
    pos: '60% 30%',
    zoom: '150%',
    image: 'scarlet_sand_sojourn.jpg',
    start: '2023-02-24 12:00:00',
    end: '2023-03-02 23:59:59',
    color: '#a3d7fe',
    url: 'https://act.hoyoverse.com/ys/event/e20230224dehya-tilwsu/index.html?game_biz=hk4e_global&hyl_presentation_style=fullscreen&hyl_auth_required=true&hyl_landscape=true&hyl_hide_status_bar=true&utm_source=hoyolab&utm_medium=post',
    showOnHome: true,
  },
  {
    name: "Windblume's Breath",
    pos: '0% 20%',
    zoom: '100%',
    image: 'windblumes_breath.jpg',
    start: '2023-03-03 10:00:00',
    end: '2023-03-20 03:59:59',
    color: '#4a9dff',
    url: 'https://www.hoyolab.com/article/16631602',
    showOnHome: true,
  },
  {
    name: 'Vibro Crystal Verification',
    pos: '0% 30%',
    zoom: '210%',
    image: 'vibro_crysta_research.jpg',
    start: '2023-03-14 10:00:00',
    end: '2023-03-27 03:59:59',
    color: '#38c2f9',
    url: 'https://www.hoyolab.com/article/16959444',
    showOnHome: true,
  },
  {
    name: 'Fungus Mechanicus',
    pos: '0% 60%',
    zoom: '200%',
    image: 'fungus_mechanicus.jpg',
    start: '2023-03-23 10:00:00',
    end: '2023-04-03 03:59:59',
    color: '#5cbcad',
    url: 'https://www.hoyolab.com/article/17144800',
    showOnHome: true,
  },
  {
    name: 'Spices From the West: Northerly Search',
    pos: '0% 40%',
    zoom: '200%',
    image: 'spices_from_the_west.jpg',
    start: '2023-03-31 10:00:00',
    end: '2023-04-10 03:59:59',
    color: '#83bfb4',
    url: 'https://www.hoyolab.com/article/17337582',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 40%',
    zoom: '200%',
    image: 'leyline_overflow.jpg',
    start: '2023-04-03 04:00:00',
    end: '2023-04-10 03:59:59',
    color: '#5baced',
    url: 'https://www.hoyolab.com/article/17374982',
    showOnHome: true,
  },
  {
    name: 'Brewing Developments',
    pos: '0% 20%',
    zoom: '250%',
    image: 'brewing_developments.jpg',
    start: '2023-04-13 10:00:00',
    end: '2023-04-24 03:59:59',
    color: '#b0f7f1',
    url: 'https://www.hoyolab.com/article/17591332',
    showOnHome: true,
  },
  {
    name: 'Fulminating Sandstorm',
    pos: '0% 20%',
    zoom: '100%',
    image: 'fulminating_sandstorm.png',
    start: '2023-04-21 10:00:00',
    end: '2023-05-01 03:59:59',
    color: '#f1eada',
    url: 'https://www.hoyolab.com/article/17591460',
    showOnHome: true,
  },
  {
    name: 'A Parade of Providence',
    pos: '20% 20%',
    zoom: '150%',
    image: 'a_parade_of_providence_full.jpg',
    start: '2023-04-27 10:00:00',
    end: '2023-05-15 03:59:59',
    color: '#e98a4a',
    url: 'https://www.hoyolab.com/article/17950597',
    showOnHome: true,
  },
  {
    name: "The Recollector's Path",
    pos: '50% 40%',
    zoom: '200%',
    image: 'the_recollectors_path_temp.png',
    start: '2023-05-08 10:00:00',
    end: '2023-05-22 03:59:59',
    color: '#efa7a9',
    url: 'https://www.hoyolab.com/article/18031376',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    image: 'overflowing_mastery.jpg',
    start: '2023-05-15 04:00:00',
    end: '2023-05-22 03:59:59',
    color: '#f5debc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/18031376',
    showOnHome: true,
  },
  {
    name: "Duel! The Summoners' Summit!",
    pos: '35% 20%',
    zoom: '250%',
    image: 'Duel The Summoners Summit.png',
    start: '2023-05-25 10:00:00',
    end: '2023-06-12 03:59:59',
    color: '#d8e29d',
    url: 'https://www.hoyolab.com/article/18699059',
    showOnHome: true,
  },
  {
    name: "Divine Ingenuity: Collector's Chapter",
    pos: '0% 20%',
    zoom: '200%',
    image: 'Divine Ingenuity 2.png',
    start: '2023-06-08 10:00:00',
    end: '2023-06-29 03:59:59',
    color: '#cbfeff',
    url: 'https://www.hoyolab.com/article/18699187',
    showOnHome: true,
  },
  {
    name: 'Feast of the Departed Warriors',
    pos: '0% 20%',
    zoom: '250%',
    image: 'Feast of the Departed Warriors.png',
    start: '2023-06-14 10:00:00',
    end: '2023-06-26 03:59:59',
    color: '#4f7eed',
    url: 'https://www.hoyolab.com/article/19277582',
    showOnHome: true,
  },
  {
    name: 'Secret Summer Paradise',
    pos: '20% 10%',
    zoom: '150%',
    image: 'Secret Summer Paradise.jpg',
    start: '2023-07-05 06:00:00',
    end: '2023-08-16 03:59:59',
    color: '#9ceddf',
    url: 'https://www.hoyolab.com/article/19771436',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: "Adventurer's Trials: Advanced",
    pos: '0% 50%',
    zoom: '150%',
    image: 'Adventurers Trials Advanced.jpg',
    start: '2023-07-20 10:00:00',
    end: '2023-07-31 03:59:59',
    color: '#fffa86',
    url: 'https://www.hoyolab.com/article/20113425',
    showOnHome: true,
  },
  {
    name: 'Perilous Expedition',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Perilous Expedition.jpg',
    start: '2023-07-27 10:00:00',
    end: '2023-08-07 03:59:59',
    color: '#edfbad',
    url: 'https://www.hoyolab.com/article/20360979',
    showOnHome: true,
  },
  {
    name: 'Shared Sight',
    pos: '0% 50%',
    zoom: '100%',
    image: 'Shared Sight Temp.png',
    start: '2023-08-03 10:00:00',
    end: '2023-08-14 03:59:59',
    color: '#d1f6a2',
    url: 'https://www.hoyolab.com/article/20180483',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    image: 'overflowing_mastery.jpg',
    start: '2023-08-07 04:00:00',
    end: '2023-08-14 03:59:59',
    color: '#f5debc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/20180483',
    showOnHome: true,
  },
  {
    name: 'Relic Records: Creations of the Hydro Nation',
    pos: '0% 50%',
    zoom: '300%',
    image: 'Relic Records Creations of the Hydro Nation.jpg',
    start: '2023-08-16 06:00:00',
    end: '2023-08-28 03:59:59',
    color: '#71d4e7',
    url: 'https://www.hoyolab.com/article/20856332',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Mega Meka Melee',
    pos: '80% 25%',
    zoom: '250%',
    image: 'Mega Meka Melee.jpg',
    start: '2023-08-24 10:00:00',
    end: '2023-09-11 03:59:59',
    color: '#a1dffe',
    url: 'https://www.hoyolab.com/article/21096726',
    showOnHome: true,
  },
  {
    name: 'Verdict of Blades',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Verdict of Blades.jpg',
    start: '2023-09-04 10:00:00',
    end: '2023-09-18 03:59:59',
    color: '#2aabff',
    url: 'https://www.hoyolab.com/article/21344686',
    showOnHome: true,
  },
  {
    name: 'Studies in Light and Shadow: A Fontaine of Enchantment',
    pos: '0% 50%',
    zoom: '200%',
    image: 'Studies in Light and Shadow A Fontaine of Enchantment temp.jpg',
    start: '2023-09-14 10:00:00',
    end: '2023-09-25 03:59:59',
    color: '#dfd2ab',
    url: 'https://www.hoyolab.com/article/21297643',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 40%',
    zoom: '200%',
    image: 'leyline_overflow.jpg',
    start: '2023-09-18 04:00:00',
    end: '2023-09-25 03:59:59',
    color: '#5baced',
    url: 'https://www.hoyolab.com/article/21297643',
    showOnHome: true,
  },
  {
    name: 'Radiant Harvest',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Radiant Harvest.jpg',
    start: '2023-09-28 10:00:00',
    end: '2023-10-09 03:59:59',
    color: '#58c3d2',
    url: 'https://www.hoyolab.com/article/21872780',
    showOnHome: true,
  },
  {
    name: 'Bathing in Flowing Moonlight: Daily Login',
    pos: '0% 40%',
    zoom: '200%',
    image: 'Bathing in Flowing Moonlight.jpg',
    start: '2023-09-29 04:00:00',
    end: '2023-10-16 03:59:59',
    color: '#ffa2b5',
    url: 'https://www.hoyolab.com/article/21872779',
    showOnHome: true,
  },
  {
    name: 'Waterbone Poetry',
    pos: '0% 30%',
    zoom: '100%',
    image: 'Waterbone Poetry tmp.jpg',
    start: '2023-10-12 10:00:00',
    end: '2023-10-30 03:59:59',
    color: '#eeecb9',
    url: 'https://www.hoyolab.com/article/21853732',
    showOnHome: true,
  },
  {
    name: 'The Peaks and Troughs of Life',
    pos: '0% 40%',
    zoom: '100%',
    image: 'The Peaks and Troughs of Life.png',
    start: '2023-10-23 10:00:00',
    end: '2023-11-06 03:59:59',
    color: '#a6ceb3',
    url: 'https://www.hoyolab.com/article/22272349',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    image: 'overflowing_mastery.jpg',
    start: '2023-10-30 04:00:00',
    end: '2023-11-06 03:59:59',
    color: '#f5debc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/22272349',
    showOnHome: true,
  },
  {
    name: 'Misty Dungeon: Realm of Water',
    pos: '0% 50%',
    zoom: '200%',
    image: 'Misty Dungeon Realm of Water.png',
    start: '2023-11-09 10:00:00',
    end: '2023-11-20 03:59:59',
    color: '#2da6b1',
    url: 'https://www.hoyolab.com/article/22800499',
    showOnHome: true,
  },
  {
    name: 'Graph Adversarial Technology Experiment Log',
    pos: '0% 50%',
    zoom: '100%',
    image: 'Graph Adversarial Technology Experiment Log.png',
    start: '2023-11-17 10:00:00',
    end: '2023-11-27 03:59:59',
    color: '#eae4dd',
    url: 'https://www.hoyolab.com/article/22782228',
    showOnHome: true,
  },
  {
    name: "Thelxie's Fantastic Adventures",
    pos: '40% 60%',
    zoom: '200%',
    image: 'Thelxies Fantastic Adventures.png',
    start: '2023-11-23 10:00:00',
    end: '2023-12-11 03:59:59',
    color: '#83abe1',
    url: 'https://www.hoyolab.com/article/23129467',
    showOnHome: true,
  },
  {
    name: "Lil' Fungi's Fun-Tastic Fiesta",
    pos: '0% 60%',
    zoom: '200%',
    image: 'fungus_mechanicus.jpg',
    start: '2023-12-06 10:00:00',
    end: '2023-12-18 03:59:59',
    color: '#5cbcad',
    url: 'https://www.hoyolab.com/article/23172422',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 40%',
    zoom: '200%',
    image: 'leyline_overflow.jpg',
    start: '2023-12-11 04:00:00',
    end: '2023-12-18 03:59:59',
    color: '#5baced',
    url: 'https://www.hoyolab.com/article/23172422',
    showOnHome: true,
  },
  {
    name: 'Roses and Muskets',
    pos: '0% 40%',
    zoom: '200%',
    image: 'Roses and Muskets.png',
    start: '2023-12-21 10:00:00',
    end: '2024-01-08 03:59:59',
    color: '#9ac4ee',
    url: 'https://www.hoyolab.com/article/23689256',
    showOnHome: true,
  },
  {
    name: 'Lost Riches',
    pos: '0% 50%',
    image: 'lost_riches_2.jpg',
    start: '2024-01-02 10:00:00',
    end: '2024-01-15 03:59:59',
    color: '#FFF2DC',
    zoom: '170%',
    url: 'https://www.hoyolab.com/article/23668604',
    showOnHome: true,
  },
  {
    name: 'Dance of Resolute Will',
    pos: '0% 40%',
    zoom: '220%',
    image: 'Dance of Resolute Will.png',
    start: '2024-01-10 10:00:00',
    end: '2024-01-22 03:59:59',
    color: '#68d6cf',
    url: 'https://www.hoyolab.com/article/24202247',
    showOnHome: true,
  },
  {
    name: 'Arataki Blazing Armor Beetle Battle Boot Camp',
    pos: '0% 50%',
    zoom: '250%',
    image: 'almighty_arataki_extraordinary_and_exhilarating_extreme_beetle_brawl.jpg',
    start: '2024-01-17 10:00:00',
    end: '2024-01-29 03:59:59',
    color: '#c8bcae',
    url: 'https://www.hoyolab.com/article/24108119',
    showOnHome: true,
  },
  {
    name: 'Marvelous Merchandise',
    pos: '0% 80%',
    image: 'marvelous_merchandise_event.jpg',
    start: '2024-01-22 10:00:00',
    end: '2024-01-29 03:59:59',
    color: '#fad688',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24108119',
    showOnHome: true,
  },
  {
    name: 'May Fortune Find You - Daily Login',
    pos: '0% 0%',
    image: 'daily_login.jpg',
    start: '2024-02-03 04:00:00',
    end: '2024-02-18 03:59:59',
    color: '#F18B53',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/24683799',
    showOnHome: true,
  },
  {
    name: 'Vibrant Harriers Aloft in Spring Breeze',
    pos: '0% 30%',
    image: 'Vibrant Harriers Aloft in Spring Breeze.png',
    start: '2024-02-05 10:00:00',
    end: '2024-02-26 03:59:59',
    color: '#f4c580',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24683838',
    showOnHome: true,
  },
  {
    name: 'Triumphant Frenzy',
    pos: '0% 40%',
    image: 'Triumphant Frenzy.png',
    start: '2024-02-15 10:00:00',
    end: '2024-02-26 03:59:59',
    color: '#d6b0b7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24683799',
    showOnHome: true,
  },
  {
    name: 'Receiver of Friends From Afar',
    pos: '0% 40%',
    image: 'Receiver of Friends From Afar.png',
    start: '2024-02-21 10:00:00',
    end: '2024-03-04 03:59:59',
    color: '#f5d377',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24708406',
    showOnHome: true,
  },
  {
    name: 'Of Kites and New Sights',
    pos: '0% 50%',
    image: 'Of Kites and New Sights.png',
    start: '2024-02-24 04:00:00',
    end: '2024-03-13 03:59:59',
    color: '#8fbcff',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24708406',
    showOnHome: true,
  },
  {
    name: 'Journey Through Hilinigmatic Terrain',
    pos: '0% 40%',
    image: 'Journey Through Hilinigmatic Terrain.png',
    start: '2024-02-29 10:00:00',
    end: '2024-03-11 03:59:59',
    color: '#cbd2b7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24708406',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2024-03-04 04:00:00',
    end: '2024-03-11 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/24708406',
    showOnHome: true,
  },
  {
    name: 'Alchemical Ascension',
    pos: '30% 20%',
    image: 'Alchemical Ascension.png',
    start: '2024-03-14 10:00:00',
    end: '2024-04-01 03:59:59',
    color: '#f6e3cc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/25852855',
    showOnHome: true,
  },
  {
    name: 'The Great Fays Reaction Debate',
    pos: '30% 20%',
    image: 'The Great Fays Reaction Debate.png',
    start: '2024-03-22 10:00:00',
    end: '2024-04-03 03:59:59',
    color: '#6edeca',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/25833336',
    showOnHome: true,
  },
  {
    name: 'Rolling Crossfire',
    pos: '0% 40%',
    image: 'Rolling Crossfire.jpg',
    start: '2024-04-01 10:00:00',
    end: '2024-04-11 03:59:59',
    color: '#8bd7f1',
    zoom: '250%',
    url: 'https://www.hoyolab.com/article/26498562',
    showOnHome: true,
  },
  {
    name: 'Feline Fotress Furrdyssey',
    pos: '0% 40%',
    image: 'Feline Fotress Furrdyssey_.jpg',
    start: '2024-04-08 10:00:00',
    end: '2024-04-18 03:59:59',
    color: '#eecaa3',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/26498562',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2024-04-15 04:00:00',
    end: '2024-04-22 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/26435017',
    showOnHome: true,
  },
  {
    name: 'Vibro-Crystal Applications',
    pos: '0% 25%',
    image: 'vibro_crysta_research.jpg',
    start: '2024-04-28 10:00:00',
    end: '2024-05-09 03:59:59',
    color: '#64a3f3',
    zoom: '220%',
    url: 'https://www.hoyolab.com/article/27519785',
    showOnHome: true,
  },
  {
    name: 'Iridescent Arataki Rockin for Life Tour de Force of Awesomeness',
    pos: '30% 30%',
    image: 'Iridescent Arataki Rockin_for Life Tour de Force of Awesomeness.png',
    start: '2024-05-06 10:00:00',
    end: '2024-05-27 03:59:59',
    color: '#eae0e4',
    zoom: '170%',
    url: 'https://www.hoyolab.com/article/28116868',
    showOnHome: true,
  },
  {
    name: 'Windtrace: Seekers and Strategy',
    pos: '0% 75%',
    image: 'Windtrace Seekers and Strategy.png',
    start: '2024-05-14 10:00:00',
    end: '2024-05-27 03:59:59',
    color: '#ffeaac',
    zoom: '220%',
    url: 'https://www.hoyolab.com/article/28436119',
    showOnHome: true,
  },
  {
    name: 'Specially-Shaped Saurian Search',
    pos: '0% 40%',
    image: 'SpeciallyShapedSaurianSearch.png',
    start: '2024-05-22 10:00:00',
    end: '2024-06-03 03:59:59',
    color: '#9cfe95',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/28345218',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    image: 'overflowing_mastery.jpg',
    start: '2024-05-27 04:00:00',
    end: '2024-06-03 03:59:59',
    color: '#f5debc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/28345218',
    showOnHome: true,
  },
  {
    name: 'Mutual Security Enhancing Simulation',
    pos: '0% 0%',
    image: 'Mutual Security Enhancing Simulation.png',
    start: '2024-06-07 10:00:00',
    end: '2024-06-17 03:59:59',
    color: '#f9e87e',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/29523218',
    showOnHome: true,
  },
  {
    name: 'Record of Refelective Writing',
    pos: '0% 0%',
    image: 'Record of Refelective Writing .png',
    start: '2024-06-18 10:00:00',
    end: '2024-06-24 03:59:59',
    color: '#ffa066',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/29435984',
    showOnHome: true,
  },
  {
    name: 'Endless Forms Most Martial',
    pos: '0% 0%',
    image: 'Endless Forms Most Martial.png',
    start: '2024-06-25 10:00:00',
    end: '2024-07-01 03:59:59',
    color: '#f0e6ca',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/30192615',
    showOnHome: true,
  },
  {
    name: 'Spino Doubleblaster',
    pos: '0% 40%',
    image: 'Spino Doubleblaster.png',
    start: '2024-07-02 10:00:00',
    end: '2024-07-08 03:59:59',
    color: '#f0e6ca',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/30072005',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2024-07-08 10:00:00',
    end: '2024-07-15 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/30072005',
    showOnHome: true,
  },
  {
    name: 'Summertide Scales and Tales',
    pos: '0% 0%',
    image: 'Summertide Scales and Tales.png',
    start: '2024-07-17 06:00:00',
    end: '2024-08-27 03:59:59',
    color: '#64b1e8',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/31070415',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Outside the Canvas, Inside the Lens: Dew-Kissed Chapter',
    pos: '0% 20%',
    image: 'outside_the_canvas_inside_the_lens.jpg',
    start: '2024-07-29 10:00:00',
    end: '2024-08-08 03:59:59',
    color: '#b1d1e6',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/31507365',
    showOnHome: true,
  },
  {
    name: 'Bing-Bang Finchball',
    pos: '0% 50%',
    image: 'Bing-Bang Finchball.png',
    start: '2024-08-06 10:00:00',
    end: '2024-08-19 03:59:59',
    color: '#c2e62b',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/31777295',
    showOnHome: true,
  },
  {
    name: 'Energy Amplifier: Lemma',
    pos: '0% 20%',
    image: 'energy_amplifier_fruition.jpg',
    start: '2024-08-12 10:00:00',
    end: '2024-08-26 03:59:59',
    color: '#41b6c8',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/31677110',
    showOnHome: true,
  },
  {
    name: 'Traces of Artistry',
    pos: '80% 40%',
    image: 'Traces of Artistry.jpg',
    start: '2024-08-28 06:00:00',
    end: '2024-09-16 03:59:59',
    color: '#f4e9a7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32519656',
    showOnHome: true,
  },
  {
    name: 'Brilliant Dawn - Daily Login',
    pos: '0% 50%',
    image: 'Brilliant Dawn.png',
    start: '2024-08-30 04:00:00',
    end: '2024-09-18 03:59:59',
    color: '#ff8d9e',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32554889',
    showOnHome: true,
  },
  {
    name: 'Where the Springs Return',
    pos: '0% 20%',
    image: 'Where the Springs Return.jpg',
    start: '2024-08-28 06:00:00',
    end: '2024-09-17 17:59:59',
    color: '#a0bbef',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32490648',
    showOnHome: true,
  },
  {
    name: 'Flowers Resplendent on the Sun-Scorched Sojourn',
    pos: '0% 25%',
    image: 'Flowers Resplendent on the Sun-Scorched Sojourn.jpg',
    start: '2024-08-28 06:00:00',
    end: '2024-10-08 14:59:59',
    color: '#ea7745',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32490648',
    showOnHome: true,
  },
  {
    name: 'Where the Springs Return',
    pos: '0% 20%',
    image: 'Where the Springs Return.jpg',
    start: '2024-08-28 06:00:00',
    end: '2024-09-17 17:59:59',
    color: '#a0bbef',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32490648',
    showOnHome: true,
  },
  {
    name: 'Traces of Artistry',
    pos: '80% 40%',
    image: 'Traces of Artistry.jpg',
    start: '2024-08-28 06:00:00',
    end: '2024-09-16 03:59:59',
    color: '#f4e9a7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32519656',
    showOnHome: true,
  },
  {
    name: "Dodoco's Boom-Bastic Escapades",
    pos: '0% 40%',
    image: 'Dodocos Boom-Bastic Escapades.png',
    start: '2024-09-09 06:00:00',
    end: '2024-09-23 03:59:59',
    color: '#fef7e4',
    zoom: '250%',
    url: 'https://www.hoyolab.com/article/33001020',
    showOnHome: true,
  },
  {
    name: "Yupanqui's Turnfire",
    pos: '0% 20%',
    image: 'Yupanquis Turnfire.jpg',
    start: '2024-09-17 18:00:00',
    end: '2024-10-08 14:59:59',
    color: '#a8d3e7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/32490648',
    showOnHome: true,
  },
  {
    name: 'Of Thorns and Crowns',
    pos: '0% 50%',
    image: 'Of Thorns and Crowns.png',
    start: '2024-09-20 10:00:00',
    end: '2024-09-30 03:59:59',
    color: '#f0954d',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/33358228',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2024-09-16 04:00:00',
    end: '2024-09-23 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/33249105',
    showOnHome: true,
  },
  {
    name: 'Mementos of Teyvat',
    pos: '0% 20%',
    image: 'Mementos of Teyvat tmp.png',
    start: '2024-09-28 06:00:00',
    end: '2024-10-08 03:59:59',
    color: '#5489ff',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/33001020',
    showOnHome: true,
  },
  {
    name: 'The Rainbow Destined to Burn',
    pos: '0% 10%',
    image: 'The Rainbow Destined to Burn.png',
    start: '2024-10-09 06:00:00',
    end: '2024-11-19 14:59:59',
    color: '#58a8ea',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/34010544',
    showOnHome: true,
  },
  {
    name: 'Aphid Treasure Trace',
    pos: '0% 25%',
    image: 'Aphid Treasure Trace.png',
    start: '2024-10-10 10:00:00',
    end: '2024-10-21 03:59:59',
    color: '#5792f7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/34043094',
    showOnHome: true,
  },
  {
    name: 'Reminiscent Regimen: Thrill',
    pos: '0% 25%',
    image: 'Reminiscent Regimen Thrill.png',
    start: '2024-10-17 10:00:00',
    end: '2024-10-28 03:59:59',
    color: '#dddbb0',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/34259331',
    showOnHome: true,
  },
  {
    name: 'Chromatic Ode of Candies and Roses',
    pos: '30% 15%',
    image: 'Chromatic Ode of Candies and Roses.png',
    start: '2024-10-23 10:00:00',
    end: '2024-11-07 03:59:59',
    color: '#e4fce2',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/34402598',
    showOnHome: true,
  },
  {
    name: 'Feast of Pursuit',
    pos: '0% 20%',
    image: 'Feast of Pursuit tmp.png',
    start: '2024-11-01 10:00:00',
    end: '2024-11-15 03:59:59',
    color: '#d5b3d1',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/34470471',
    showOnHome: true,
  },
  {
    name: 'Marvelous Merchandise',
    pos: '0% 80%',
    image: 'marvelous_merchandise_event.jpg',
    start: '2024-11-11 10:00:00',
    end: '2024-11-18 03:59:59',
    color: '#fad688',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/34470471',
    showOnHome: true,
  },
  {
    name: 'Claw Convoy',
    pos: '0% 35%',
    zoom: '200%',
    image: 'Claw Convoy 2.png',
    start: '2024-11-22 10:00:00',
    end: '2024-12-02 03:59:59',
    color: '#ebf97b',
    url: 'https://www.hoyolab.com/article/35053992',
    showOnHome: true,
  },
  {
    name: 'Iktomi Spiritseeking Scrolls',
    pos: '0% 35%',
    zoom: '100%',
    image: 'Iktomi Spiritseeking Scrolls.jpg',
    start: '2024-11-28 10:00:00',
    end: '2024-12-16 03:59:59',
    color: '#6583e2',
    url: 'https://www.hoyolab.com/article/35015809',
    showOnHome: true,
  },
  {
    name: 'Of Fading Flowers and Falling Feathers',
    pos: '0% 15%',
    zoom: '200%',
    image: 'Of Fading Flowers and Falling Feathers.png',
    start: '2024-11-20 06:00:00',
    end: '2024-12-10 17:59:59',
    color: '#c2c5ff',
    url: 'https://www.hoyolab.com/article/35015714',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: "Adventurer's Trials: Metamorphosis",
    pos: '0% 15%',
    zoom: '200%',
    image: 'Adventurers Trials Metamorphosis.png',
    start: '2024-12-11 10:00:00',
    end: '2024-12-23 03:59:59',
    color: '#8dc2f2',
    url: 'https://www.hoyolab.com/article/35477560',
    showOnHome: true,
  },
  {
    name: 'Exercise Surging Storm',
    pos: '0% 0%',
    zoom: '200%',
    image: 'Exercise Surging Storm.png',
    start: '2024-12-18 10:00:00',
    end: '2024-12-30 03:59:59',
    color: '#e5b88a',
    url: 'https://www.hoyolab.com/article/35393996',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2024-12-23 04:00:00',
    end: '2024-12-30 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/35393996',
    showOnHome: true,
  },
  {
    name: 'Memories Flowing With Color',
    pos: '0% 20%',
    image: 'Memories Flowing With Color.png',
    start: '2025-01-01 06:00:00',
    end: '2025-01-21 17:59:59',
    color: '#f6c3b7',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/35948962',
    showOnHome: true,
  },
  {
    name: 'As the Blazing Sun',
    pos: '0% 20%',
    image: 'As the Blazing Sun.png',
    start: '2025-01-01 06:00:00',
    end: '2025-01-21 17:59:59',
    color: '#ffbebe',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/35948965',
    showOnHome: true,
  },
  {
    name: "Shuyu's Baffling Beetle Battle Bowl",
    pos: '0% 30%',
    zoom: '100%',
    image: 'shuyus baffling beetle battle bowl tmp.png',
    start: '2025-01-03 10:00:00',
    end: '2025-01-13 03:59:59',
    color: '#d8c43e',
    url: 'https://www.hoyolab.com/article/35949127',
    showOnHome: true,
  },
  {
    name: 'Emblem of Steadfast Valor',
    pos: '0% 50%',
    zoom: '100%',
    image: 'emblem of steadfast valor tmp.png',
    start: '2025-01-09 10:00:00',
    end: '2025-01-20 03:59:59',
    color: '#c8d4eb',
    url: 'https://www.hoyolab.com/article/35949127',
    showOnHome: true,
  },
  {
    name: 'On the Trail of Behemoths',
    pos: '0% 60%',
    zoom: '100%',
    image: 'on the trail of behemoths tmp.png',
    start: '2025-01-14 10:00:00',
    end: '2025-01-27 03:59:59',
    color: '#eae1d1',
    url: 'https://www.hoyolab.com/article/35949127',
    showOnHome: true,
  },
  {
    name: 'May Fortune Find You - Daily Login',
    pos: '0% 20%',
    image: 'daily_login.jpg',
    start: '2025-01-22 04:00:00',
    end: '2025-02-11 14:59:59',
    color: '#F18B53',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/35949127',
    showOnHome: true,
  },
  {
    name: 'Springtime Charms',
    pos: '30% 20%',
    zoom: '200%',
    image: 'springtime charms tmp.png',
    start: '2025-01-24 10:00:00',
    end: '2025-02-09 03:59:59',
    color: '#ffc297',
    url: 'https://www.hoyolab.com/article/36388407',
    showOnHome: true,
  },
  {
    name: 'Overflowing Mastery',
    pos: '0% 50%',
    image: 'overflowing_mastery.jpg',
    start: '2025-02-03 04:00:00',
    end: '2025-02-10 03:59:59',
    color: '#f5debc',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/36388407',
    showOnHome: true,
  },
  {
    name: 'Tapirus Somniator Chapter',
    pos: '0% 20%',
    image: 'Tapirus Somniator Chapter.png',
    start: '2025-02-12 06:00:00',
    end: '2025-03-04 17:59:59',
    color: '#13a5ff',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/36971026',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: "Travelers' Tales: Anthology Chapter",
    pos: '0% 40%',
    image: 'Travelers Tales Anthology Chapter.png',
    start: '2025-02-12 06:00:00',
    end: '2025-03-25 14:59:59',
    color: '#f0e873',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/36971022',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Enchanted Tales of the Mikawa Festival',
    pos: '0% 20%',
    image: 'Enchanted Tales of the Mikawa Festival.png',
    start: '2025-02-14 10:00:00',
    end: '2025-03-03 03:59:59',
    color: '#ffd8ee',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/36971146',
    showOnHome: true,
  },
  {
    name: 'Realm of Tempered Valor',
    pos: '0% 30%',
    image: 'Realm of Tempered Valor.png',
    start: '2025-02-24 10:00:00',
    end: '2025-03-10 03:59:59',
    color: '#e6e4c4',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/36971146',
    showOnHome: true,
  },
  {
    name: 'Invasive Fish Wrangler',
    pos: '0% 40%',
    image: 'Invasive Fish Wrangler.png',
    start: '2025-03-05 10:00:00',
    end: '2025-03-17 03:59:59',
    color: '#00b1e1',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/37397966',
    showOnHome: true,
  },
  {
    name: 'Reel Ad-Venture',
    pos: '0% 40%',
    image: 'Reel Ad-Venture tmp.png',
    start: '2025-03-12 10:00:00',
    end: '2025-03-24 03:59:59',
    color: '#fff358',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/37319302',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 20%',
    image: 'leyline_overflow.jpg',
    start: '2025-03-17 04:00:00',
    end: '2025-03-24 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/37319302',
    showOnHome: true,
  },
  {
    name: 'Treasured Above All',
    pos: '0% 20%',
    image: 'Treasured Above All.png',
    start: '2025-05-07 06:00:00',
    end: '2025-05-27 17:59:59',
    color: '#FDF9FA',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/38610999',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Whirling Waltz',
    pos: '0% 10%',
    image: 'Whirling Waltz.png',
    start: '2025-05-09 10:00:00',
    end: '2025-05-26 03:59:59',
    color: '#9CD2F0',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/38644747',
    showOnHome: true,
  },
  {
    name: 'Operation Downpour Simulation',
    pos: '0% 30%',
    image: 'Operation Downpour Simulation.png',
    start: '2025-05-19 10:00:00',
    end: '2025-06-03 03:59:59',
    color: '#FDEB87',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/38611112',
    showOnHome: true,
  },
  {
    name: 'Chronicle of Shifting Stratagems',
    pos: '0% 10%',
    image: 'Chronicle of Shifting Stratagems.png',
    start: '2025-05-27 10:00:00',
    end: '2025-06-09 03:59:59',
    color: '#bde1e9',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/38968109',
    showOnHome: true,
  },
  {
    name: 'Legends Ablaze: Cross-Border Brawl',
    pos: '0% 50%',
    image: 'Legends Ablaze Cross Border Brawl tmp.png',
    start: '2025-06-05 10:00:00',
    end: '2025-06-16 17:59:59',
    color: '#74e1f1',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/38918167',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 40%',
    image: 'leyline_overflow.jpg',
    start: '2025-06-09 04:00:00',
    end: '2025-06-16 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/38918167',
    showOnHome: true,
  },
  {
    name: "Travelers' Tales: Gilded Chapter",
    pos: '0% 40%',
    image: 'Travelers Tales Gilded Chapter.png',
    start: '2025-06-18 06:00:00',
    end: '2025-07-29 14:59:59',
    color: '#f0e873',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/39353507',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Crystallina Chapter',
    pos: '0% 12%',
    image: 'Crystallina Chapter.png',
    start: '2025-06-18 06:00:00',
    end: '2025-07-08 03:59:59',
    color: '#859be6',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/39353508',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Battle of Imagined Arrays',
    pos: '60% 30%',
    image: 'Battle of Imagined Arrays.png',
    start: '2025-06-20 10:00:00',
    end: '2025-07-07 03:59:59',
    color: '#c2e9b3',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/39388504',
    showOnHome: true,
  },
  {
    name: 'Overflowing Abundance',
    pos: '0% 40%',
    image: 'Overflowing Abundance.png',
    start: '2025-07-07 04:00:00',
    end: '2025-07-14 03:59:59',
    color: '#f1c852',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/39801558',
    showOnHome: true,
  },
  {
    name: 'Reminiscent Regimen: Frenzy',
    pos: '0% 40%',
    image: 'Reminiscent Regimen Frenzy tmp.webp',
    start: '2025-07-14 10:00:00',
    end: '2025-07-24 03:59:59',
    color: '#b3e6fd',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/39785867',
    showOnHome: true,
  },
  {
    name: 'Fearsome Ferocious Firepower',
    pos: '0% 40%',
    image: 'Fearsome Ferocious Firepower tmp.webp',
    start: '2025-07-21 10:00:00',
    end: '2025-07-29 03:59:59',
    color: '#90d3f4',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/39785867',
    showOnHome: true,
  },
  {
    name: 'An Easy-Breezy Natlan in an Easy-Breezy Summer!',
    pos: '0% 10%',
    image: 'An Easy-Breezy Natlan in an Easy-Breezy Summer.png',
    start: '2025-07-30 06:00:00',
    end: '2025-10-21 14:59:59',
    color: '#4c94ee',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/40226688',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Song of the Welkin Moon — Prelude',
    pos: '0% 14%',
    zoom: '200%',
    image: 'Song of the Welkin Moon.png',
    start: '2025-07-30 06:00:00',
    end: '2025-09-09 14:59:59',
    color: '#ceeff6',
    url: 'https://www.hoyolab.com/article/40226789',
  },
  {
    name: 'Sunspray Summer Resort',
    pos: '0% 40%',
    image: 'Sunspray Summer Resort.png',
    start: '2025-07-30 06:00:00',
    end: '2025-08-18 03:59:59',
    color: '#9bd7f0',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/40226688',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Tracing Vanishing Trails',
    pos: '0% 10%',
    image: 'Tracing Vanishing Trails A.png',
    start: '2025-08-14 10:00:00',
    end: '2025-08-25 03:59:59',
    color: '#a7d6f6',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/40226789',
    showOnHome: true,
  },
  {
    name: 'Mementos of Teyvat: Prelude of the Frozen Veil',
    pos: '0% 40%',
    image: 'Mementos of Teyvat Prelude of the Frozen Veil.png',
    start: '2025-08-21 10:00:00',
    end: '2025-09-01 03:59:59',
    color: '#6175cd',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/40616469',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '20% 35%',
    image: 'leyline_overflow.jpg',
    start: '2025-09-01 04:00:00',
    end: '2025-09-08 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/40539069',
    showOnHome: true,
  },
  {
    name: 'An Elegy for Faded Moonlight',
    pos: '0% 20%',
    zoom: '200%',
    image: 'An Elegy for Faded Moonlight.png',
    start: '2025-10-22 06:00:00',
    end: '2025-12-02 03:59:00',
    color: '#b797ff',
    url: 'https://www.hoyolab.com/article/41848206',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Saurian Sojourn',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Saurian Sojourn.png',
    start: '2025-10-24 10:00:00',
    end: '2025-11-03 03:59:00',
    color: '#93e1fb',
    url: 'https://www.hoyolab.com/article/41877259',
    showOnHome: true,
  },
  {
    name: 'Ruins Exploration: Fieldwise Center',
    pos: '0% 50%',
    zoom: '200%',
    image: 'Ruins Exploration Fieldwise Center.png',
    start: '2025-11-07 10:00:00',
    end: '2025-11-24 03:59:00',
    color: '#ecdb9b',
    url: 'https://www.hoyolab.com/article/42170224',
    showOnHome: true,
  },
  {
    name: 'Dance Dance Dynamic Disco',
    pos: '0% 10%',
    zoom: '200%',
    image: 'Dance Dance Dynamic Disco.png',
    start: '2025-11-17 10:00:00',
    end: '2025-11-26 03:59:00',
    color: '#b2e5ff',
    url: 'https://www.hoyolab.com/article/42343297',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '20% 35%',
    image: 'leyline_overflow.jpg',
    start: '2025-11-24 04:00:00',
    end: '2025-12-01 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/42197626',
    showOnHome: true,
  },
  {
    name: 'A Nocturne of the Far North',
    pos: '0% 20%',
    zoom: '200%',
    image: 'A Nocturne of the Far North.png',
    start: '2025-12-03 06:00:00',
    end: '2026-01-13 14:59:00',
    color: '#eceff3',
    url: 'https://www.hoyolab.com/article/42564003',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Bing-Bang Finchball',
    pos: '0% 50%',
    zoom: '200%',
    image: 'Bing-Bang Finchball.png',
    start: '2025-12-05 10:00:00',
    end: '2025-12-15 03:59:00',
    color: '#fdfccc',
    url: 'https://www.hoyolab.com/article/42564048',
    showOnHome: true,
  },
  {
    name: "Soulblazers' Snowbound Journey",
    pos: '40% 20%',
    zoom: '150%',
    image: 'Soulblazers Snowbound Journey.png',
    start: '2025-12-19 10:00:00',
    end: '2026-01-05 03:59:00',
    color: '#c8ebf8',
    url: 'https://www.hoyolab.com/article/42802603',
    showOnHome: true,
  },
  {
    name: 'Heroic Clash: Saurian Brawl',
    pos: '0% 70%',
    zoom: '100%',
    image: 'Heroic Clash Saurian Brawl tmp.png',
    start: '2025-12-29 10:00:00',
    end: '2026-01-07 03:59:00',
    color: '#c7e272',
    url: 'https://www.hoyolab.com/article/42820209',
    showOnHome: true,
  },
  {
    name: 'Marvelous Merchandise',
    pos: '0% 80%',
    image: 'marvelous_merchandise_event.jpg',
    start: '2026-01-05 10:00:00',
    end: '2026-01-12 03:59:59',
    color: '#fad688',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/42820209',
    showOnHome: true,
  },
  {
    name: "A Traveler on a Winter's Night",
    pos: '0% 0%',
    zoom: '200%',
    image: 'A Traveler on a Winters Night.png',
    start: '2026-01-14 06:00:00',
    end: '2026-02-24 14:59:00',
    color: '#cee5eb',
    url: 'https://www.hoyolab.com/article/42564003',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: "Fortune's Coming - Daily Login",
    pos: '0% 20%',
    image: 'daily_login.jpg',
    start: '2026-01-16 04:00:00',
    end: '2026-02-03 03:59:59',
    color: '#F18B53',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/43195241',
    showOnHome: true,
  },
  {
    name: 'Shutterflash Memory Hunt',
    pos: '0% 10%',
    image: 'Shutterflash Memory Hunt.png',
    start: '2026-01-16 10:00:00',
    end: '2026-01-26 03:59:00',
    color: '#fef9e2',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/43195241',
    showOnHome: true,
  },
  {
    name: 'Serene Moonlit Night - Lantern Rite Gifts',
    pos: '0% 20%',
    image: '',
    start: '2026-01-30 00:00:00',
    end: '2026-02-03 00:00:00',
    color: '#c3e0f4',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/43195241',
    showOnHome: true,
  },
  {
    name: 'A Lanternlit Ode to the Silver Moon',
    pos: '0% 20%',
    zoom: '200%',
    image: 'A Lanternlit Ode to the Silver Moon.png',
    start: '2026-01-30 10:00:00',
    end: '2026-02-23 03:59:00',
    color: '#eceff3',
    url: 'https://www.hoyolab.com/article/43503608',
    showOnHome: true,
  },
  {
    name: 'Moonlit Patrol Exercise',
    pos: '0% 10%',
    image: 'Moonlit Patrol Exercise tmp.png',
    start: '2026-02-09 10:00:00',
    end: '2026-02-23 03:59:59',
    color: '#fee888',
    zoom: '100%',
    url: 'https://www.hoyolab.com/article/43533410',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '20% 35%',
    image: 'leyline_overflow.jpg',
    start: '2026-02-16 04:00:00',
    end: '2026-02-23 03:59:59',
    color: '#5baced',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/43533410',
    showOnHome: true,
  },
  {
    name: 'Lupus Majoris Chapter',
    pos: '0% 0%',
    zoom: '200%',
    image: 'Lupus Majoris Chapter.png',
    start: '2026-02-25 06:00:00',
    end: '2026-03-17 17:59:00',
    color: '#1db7dd',
    url: 'https://www.hoyolab.com/article/43911909',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Homeward, He Who Caught the Wind',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Homeward, He Who Caught the Wind.png',
    start: '2026-02-27 10:00:00',
    end: '2026-03-16 03:59:00',
    color: '#8fedcd',
    url: 'https://www.hoyolab.com/article/43941713',
    showOnHome: true,
  },
  {
    name: 'Sightseeing With Friends',
    pos: '0% 60%',
    zoom: '200%',
    image: 'Sightseeing With Friends.png',
    start: '2026-03-16 10:00:00',
    end: '2026-03-26 03:59:00',
    color: '#89e6e9',
    url: 'https://www.hoyolab.com/article/44179332',
    showOnHome: true,
  },
  {
    name: 'Operation Stronghold Defense',
    pos: '0% 30%',
    zoom: '200%',
    image: 'Operation Stronghold Defense.png',
    start: '2026-03-23 10:00:00',
    end: '2026-04-02 03:59:00',
    color: '#eec85e',
    url: 'https://www.hoyolab.com/article/44273375',
    showOnHome: true,
  },
  {
    name: 'Overflowing Abundance',
    pos: '0% 40%',
    image: 'Overflowing Abundance.png',
    start: '2026-03-30 04:00:00',
    end: '2026-04-06 03:59:59',
    color: '#f1c852',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/44378370',
    showOnHome: true,
  },
  {
    name: 'Surveying & Mapping Studies',
    pos: '0% 70%',
    zoom: '200%',
    image: 'Surveying Mapping Studies.png',
    start: '2026-04-10 10:00:00',
    end: '2026-04-20 03:59:00',
    color: '#eec85e',
    url: 'https://www.hoyolab.com/article/44541722',
    showOnHome: true,
  },
  {
    name: 'Alcyon Chapter',
    pos: '0% 30%',
    zoom: '200%',
    image: 'Alcyon Chapter.png',
    start: '2026-04-08 06:00:00',
    end: '2026-04-28 03:59:00',
    color: '#928eff',
    url: 'https://www.hoyolab.com/article/44512632',
    showOnHome: true,
  },
  {
    name: 'Where Waves Meet the Reef',
    pos: '0% 30%',
    zoom: '200%',
    image: 'Where Waves Meet the Reef.png',
    start: '2026-04-27 10:00:00',
    end: '2026-05-14 03:59:00',
    color: '#c8f8fd',
    url: 'https://www.hoyolab.com/article/44793015',
    showOnHome: true,
  },
  {
    name: 'Rapid Capture',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Rapid Capture.png',
    start: '2026-05-06 10:00:00',
    end: '2026-05-18 03:59:00',
    color: '#e6d8b9',
    url: 'https://www.hoyolab.com/article/44765428',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 35%',
    image: 'leyline_overflow.jpg',
    start: '2026-05-11 04:00:00',
    end: '2026-05-18 03:59:59',
    color: '#43DA8C',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/44765428',
    showOnHome: true,
  },
  {
    name: 'Phantasmal Pals',
    pos: '80% 10%',
    zoom: '150%',
    image: 'Phantasmal Pals.png',
    start: '2026-05-22 10:00:00',
    end: '2026-06-08 03:59:00',
    color: '#7b82e3',
    url: 'https://www.hoyolab.com/article/45098983',
    showOnHome: true,
  },
  {
    name: 'Trials of the Brave Warrior',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Trials of the Brave Warrior.png',
    start: '2026-06-08 10:00:00',
    end: '2026-06-18 03:59:00',
    color: '#7b89cf',
    url: 'https://www.hoyolab.com/article/45349300',
    showOnHome: true,
  },
  {
    name: 'Kaleidoscopic Color Chase',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Kaleidoscopic Color Chase tmp.webp',
    start: '2026-06-18 10:00:00',
    end: '2026-06-29 03:59:00',
    color: '#f4d6e7',
    url: 'https://www.hoyolab.com/article/45318238',
    showOnHome: true,
  },
  {
    name: 'Sunny Summer Fontinalia',
    pos: '0% 20%',
    zoom: '150%',
    image: 'Sunny Summer Fontinalia.png',
    start: '2026-07-01 06:00:00',
    end: '2026-08-11 03:59:00',
    color: '#79bff8',
    url: 'https://www.hoyolab.com/article/45647743',
    showOnHome: true,
  },
  {
    name: 'Final Long-Range Sightlines',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Final Long-Range Sightlines.png',
    start: '2026-07-17 10:00:00',
    end: '2026-07-27 03:59:00',
    color: '#d8c4bf',
    url: 'https://www.hoyolab.com/article/45854224',
    showOnHome: true,
  },
  {
    name: 'Dance Dance Easy-Breezy Disco',
    pos: '0% 20%',
    zoom: '200%',
    image: 'Dance Dance Easy-Breezy Disco.png',
    start: '2026-07-24 10:00:00',
    end: '2026-08-03 03:59:00',
    color: '#ccf3bc',
    url: 'https://www.hoyolab.com/article/45955087',
    showOnHome: true,
  },
  {
    name: 'Ley Line Overflow',
    pos: '0% 35%',
    image: 'leyline_overflow.jpg',
    start: '2026-08-03 04:00:00',
    end: '2026-08-10 03:59:59',
    color: '#43DA8C',
    url: 'https://www.hoyolab.com/article/44765428',
    showOnHome: true,
  },
  {
    name: 'Mutual Aid in Bloom: Into the Frostlands',
    pos: '0% 50%',
    zoom: '200%',
    image: 'Mutual Aid in Bloom Into the Frostlands.png',
    start: '2026-08-12 06:00:00',
    end: '2026-08-24 03:59:59',
    color: '#b6e6ff',
    url: 'https://www.hoyolab.com/article/46208654',
    timezoneDependent: true,
    showOnHome: true,
  },
  {
    name: 'Everwinter Without Mercy',
    pos: '0% 0%',
    zoom: '100%',
    image: 'Everwinter Without Mercy.png',
    start: '2026-08-12 06:00:00',
    end: '2026-09-22 14:59:59',
    color: '#6ea6d3',
    url: 'https://www.hoyolab.com/article/46208654',
    timezoneDependent: true,
  },
  {
    name: 'Great Expeditionist Challenge',
    pos: '0% 0%',
    zoom: '100%',
    image: 'Great Expeditionist Challenge.png',
    start: '2026-08-28 10:00:00',
    end: '2026-09-14 03:59:59',
    color: '#88d8fb',
    url: 'https://www.hoyolab.com/article/46208654',
  },
  {
    name: 'Trial of the Bastion',
    pos: '0% 70%',
    zoom: '100%',
    image: 'Trial of the Bastion tmp.webp',
    start: '2026-09-07 10:00:00',
    end: '2026-09-17 03:59:00',
    color: '#e9dede',
    url: 'https://www.hoyolab.com/article/46469879',
    showOnHome: true,
  },
  {
    name: 'Overflowing Abundance',
    pos: '0% 40%',
    image: 'Overflowing Abundance.png',
    start: '2026-09-14 04:00:00',
    end: '2026-09-21 03:59:59',
    color: '#f1c852',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/46469879',
    showOnHome: true,
  },
  {
    name: "Tabletop Troupe: A Gathering on Adventure's Eve",
    pos: '0% 10%',
    zoom: '100%',
    image: 'Tabletop Troupe A Gathering on Adventures Eve.png',
    start: '2026-09-23 06:00:00',
    end: '2026-11-03 14:59:00',
    color: '#d6aa7f',
    url: 'https://www.hoyolab.com/article/46771528',
    showOnHome: true,
  },
  {
    name: "Across the Frozen Wilds, Honing One's Edge",
    pos: '0% 10%',
    zoom: '100%',
    image: 'Across the Frozen Wilds Honing Ones Edge.png',
    start: '2026-09-23 06:00:00',
    end: '2026-11-03 14:59:00',
    color: '#d5f1ec',
    url: 'https://www.hoyolab.com/article/46771528',
    showOnHome: true,
  },
  {
    name: 'A Rekviem for the Underworld',
    pos: '0% 0%',
    zoom: '100%',
    image: 'A Rekviem for the Underworld.png',
    start: '2026-09-23 06:00:00',
    end: '2026-11-03 14:59:59',
    color: '#f25a69',
    url: 'https://www.hoyolab.com/article/46771527',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Silverwing in Pursuit of the Moon',
    pos: '0% 30%',
    image: 'Silverwing in Pursuit of the Moon.png',
    start: '2026-09-24 10:00:00',
    end: '2026-10-12 03:59:59',
    color: '#d3d095',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/46782339',
    showOnHome: true,
  },
  {
    name: 'Missive of Grace: A Thank-You Gift',
    pos: '0% 40%',
    zoom: '200%',
    image: 'Rainbows End Resplendent Starlight.png',
    start: '2026-09-28 00:00:00',
    end: '2026-11-02 03:59:00',
    color: '#87b1e2',
    url: 'https://www.hoyolab.com/article/46771533',
    showOnHome: true,
  },
  {
    name: 'Resplendent Starlight - Daily Login',
    pos: '0% 40%',
    zoom: '200%',
    image: 'Rainbows End Resplendent Starlight.png',
    start: '2026-10-01 04:00:00',
    end: '2026-10-19 03:59:00',
    color: '#87b1e2',
    url: 'https://www.hoyolab.com/article/46771533',
    showOnHome: true,
  },
  {
    name: 'Predictive Victory Dynamics',
    pos: '0% 60%',
    zoom: '300%',
    image: 'Predictive Victory Dynamics.png',
    start: '2026-10-11 22:00:00',
    end: '2026-10-19 21:59:00',
    color: '#fae280',
    url: 'https://www.hoyolab.com/article/47031716',
    showOnHome: true,
  },
  {
    name: 'Carefree Snowball Fight',
    pos: '0% 30%',
    image: 'Carefree Snowball Fight.png',
    start: '2026-10-21 10:00:00',
    end: '2026-11-02 03:59:59',
    color: '#d9f0f8',
    zoom: '150%',
    url: 'https://www.hoyolab.com/article/47130835',
    showOnHome: true,
  },
  {
    name: 'Overflowing Favor',
    pos: '0% 60%',
    image: 'Overflowing Favor.png',
    start: '2026-10-26 04:00:00',
    end: '2026-11-02 03:59:59',
    color: '#d3f4fd',
    zoom: '200%',
    url: 'https://www.hoyolab.com/article/47058278',
    showOnHome: true,
  },
  {
    name: 'The Grand Defense: Defy the Unjust Judgment',
    pos: '0% 30%',
    zoom: '100%',
    image: 'The Grand Defense Defy the Unjust Judgment.png',
    start: '2026-11-04 06:00:00',
    end: '2026-12-16 05:59:59',
    color: '#ddd0b0',
    url: 'https://www.hoyolab.com/article/47284166',
    showOnHome: true,
    timezoneDependent: true,
  },
  {
    name: 'Hour of Ruin',
    pos: '0% 0%',
    zoom: '100%',
    image: 'Hour of Ruin.png',
    start: '2026-11-04 06:00:00',
    end: '2026-12-15 14:59:59',
    color: '#abc3e3',
    url: 'https://www.hoyolab.com/article/47284167',
    showOnHome: true,
    timezoneDependent: true,
  },
];
